import { Spinner, Flex, AlertIcon, AlertDescription, FormLabel, Alert,useColorModeValue } from '@chakra-ui/react'; 
import {
  Select,
} from "chakra-react-select";

import { useQuery } from "react-query";

import InputField from "components/fields/InputField";


import useAuthContext from 'hooks/useAuthContext';

import { NO_RESULT, TIME_CACHE_LONG, NO_SELECTED, 
  MODULO_ESTADO_CUENTA, MODULO_RECLAMOS, MODULO_REPORTE_ADMINISTRATIVO, MODULO_REPORTE_OPERATIVO, MODULO_WEB_TRACKING } from "const/CommonConst";
 

import service from 'services/clienteService';
import { useEstadoCuentaStore } from 'store/estadoCuentaStore';
import { useReclamosLineaStore } from 'store/reclamosLineaStore';
import { useReporteGastosStore } from 'store/reporteGastosStore';
import { useReporteOperativoStore } from 'store/reporteOperativoStore';
import { useWebTrackingStore } from 'store/webTrackingStore';

export default function ClientesUsuarioSelect(props: {
	disabled?: Boolean;
  currentStorage: Number
})  {
  
  const { getCurrentUser } = useAuthContext();

  const currentUser = getCurrentUser();
	
  const TITLE = 'Cliente'
  const KEY_FILTER = "clienteSelect";
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  
  const clienteEstadoCuenta = useEstadoCuentaStore(state => state.cliente);
  const clienteReclamos = useReclamosLineaStore(state => state.cliente);
  const clienteReporteGastos = useReporteGastosStore(state => state.cliente);
  const clienteReporteOperativo = useReporteOperativoStore(state => state.cliente);
  const clienteWebTracking = useWebTrackingStore(state => state.cliente);

  const updateClienteEstadoCuenta = useEstadoCuentaStore(state => state.updateCliente);
  const updateClienteReclamos = useReclamosLineaStore(state => state.updateCliente);
  const updateClienteReporteGastos = useReporteGastosStore(state => state.updateCliente);
  const updateClienteReporteOperativo = useReporteOperativoStore(state => state.updateCliente);
  const updateClienteWebTracking = useWebTrackingStore(state => state.updateCliente);

	const cliente = props.currentStorage === MODULO_ESTADO_CUENTA ? clienteEstadoCuenta :
                    (props.currentStorage === MODULO_RECLAMOS ? clienteReclamos :
                    (props.currentStorage === MODULO_REPORTE_ADMINISTRATIVO ? clienteReporteGastos :
                    (props.currentStorage === MODULO_REPORTE_OPERATIVO ? clienteReporteOperativo :
                    (props.currentStorage === MODULO_WEB_TRACKING ? clienteWebTracking : ""))));

  const updateCliente = props.currentStorage === MODULO_ESTADO_CUENTA ? updateClienteEstadoCuenta :
                    (props.currentStorage === MODULO_RECLAMOS ? updateClienteReclamos :
                    (props.currentStorage === MODULO_REPORTE_ADMINISTRATIVO ? updateClienteReporteGastos :
                    (props.currentStorage === MODULO_REPORTE_OPERATIVO ? updateClienteReporteOperativo :
                    (props.currentStorage === MODULO_WEB_TRACKING ? updateClienteWebTracking : null))));

  const fetchData = async () => {

    const tempData = await service.getClientesDelUsuario(currentUser);

    if (tempData.length > 0) {
      updateCliente(tempData[0].cliente);
    }

    return tempData;
  };

    const { status, data, error, isFetching } = useQuery({
      queryKey: KEY_FILTER,
      queryFn: fetchData,
      staleTime: TIME_CACHE_LONG,
    });

      if (status === "loading") {
        return (
          <Flex direction='column'>
          <FormLabel
            ms='10px'
            htmlFor='client'
            fontSize='sm'
            color={textColorPrimary}
            fontWeight='bold'
            _hover={{ cursor: 'pointer' }}>
            {TITLE}
          </FormLabel>
          <Spinner
              thickness='4px'
              speed='0.65s'
              emptyColor='gray.200'
              color='blue.500'
              size='md'
            />
            </Flex>
        );
      }
      
      if (status === "error") {
        return (
        <Flex direction='column'>
        <FormLabel
          ms='10px'
          htmlFor={KEY_FILTER}
          fontSize='sm'
          color={textColorPrimary}
          fontWeight='bold'
          _hover={{ cursor: 'pointer' }}>
          {TITLE}
        </FormLabel><Alert status='error'>
        <AlertIcon />
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
            </Flex>);
      }
      
      if (data.length === 0){
          return (
          <Flex direction='column'>
          <FormLabel
            ms='10px'
            htmlFor={KEY_FILTER}
            fontSize='sm'
            color={textColorPrimary}
            fontWeight='bold'
            _hover={{ cursor: 'pointer' }}>
            {TITLE}
          </FormLabel><Alert status='info'>
          <AlertIcon />
          <AlertDescription>{NO_RESULT}</AlertDescription>
        </Alert>
            </Flex>);
      }

	
		const options = data.map(item => {
			return {
        value: item.cliente,
        label: `${item.cliente} - ${item.nombre}`,
    };
		});

   if (options.length <= 1 || props.disabled){
    const defaultSelection = options[0];
    
    return (
      <InputField mb='0px' me='30px' id={KEY_FILTER} label={TITLE} value={defaultSelection.label} isDisabled={true} />
    );
   }

	return (    
    <Flex direction='column'>
							<FormLabel
								ms='10px'
								htmlFor={KEY_FILTER}
								fontSize='sm'
								color={textColorPrimary}
								fontWeight='bold'
								_hover={{ cursor: 'pointer' }}>
								{TITLE}
							</FormLabel>
    <Select
								fontSize='sm'
								id={KEY_FILTER}
								variant='main'
								h='44px'
								maxH='44px'
								me='20px'
                placeholder={NO_SELECTED}
								defaultValue={
                  cliente != ''
                    ? options.filter((r) => r.value == cliente)
                    : options[0]
                }
                options={options}
                onChange={(selected) => updateCliente(selected.value)}
                />
                </Flex>
  );
}